// extracted by mini-css-extract-plugin
module.exports = {"gallery-item":"GalleryItem_gallery-item__S3Ezw"};